var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"subtitle":_vm.subtitle,"title":"Avaliação antropométrica"}},[_c('Form',{ref:"Form",attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }